import { render, staticRenderFns } from "./CustomizeMetalV.vue?vue&type=template&id=902268c4&scoped=true"
import script from "./CustomizeMetalV.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalV.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalV.vue?vue&type=style&index=0&id=902268c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902268c4",
  null
  
)

export default component.exports